export default {
    data: {
        apiError: false,
        errorMsg: false
    },
    methods: {
        handleApiError: function( error ){
            if (error && error.response && error.response.status && JSON.stringify(error.response.status) === '404') {
                window.location.replace("/page_not_found");
                return;
            }

            if(error && error.response && error.response.status == 500){
                this.apiError = error.message;
                this.errorMsg = "<strong>API Fehler:</strong> Es ist ein interner Fehler auf der Twerenbold Reisedaten API aufgetreten. - Bitte versuchen Sie es später nochmals."
                return;
            }

            if(error && error.message){
                this.apiError = error.message;
            } else if(error) {
                this.apiError = error;
            } else {
                this.apiError = 'empty error object'
            }
            this.errorMsg = "<strong>API Fehler:</strong> Es ist ein Fehler bei der Verbindung mit der Twerenbold Reisedaten API aufgetreten: " + this.apiError + " - Bitte versuchen Sie es später nochmals."
        }
    }
};